import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonWidgetCustomComponent} from '../components/button.widget.custom/button.widget.custom.component';
import {TranslateModule} from '../../translate/translate.module';
import {CheckboxComponent} from '../components/checkbox/checkbox.component';

@NgModule({
  declarations: [ButtonWidgetCustomComponent, CheckboxComponent],
  exports: [ButtonWidgetCustomComponent, CheckboxComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: []
})
export class MockModule { }
